module.exports = __webpack_public_path__ + "img/Frame kantoor.3874d6f4.jpg";